import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const Layout = () => {
  return (
    // "container" and "white" background theme from your style.css
    <div className="app-wrapper">
      
      <nav>
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            PropTradingInfra<em>.com</em>
          </Link>
          
          <div className="nav-links">
            <Link to="/">Platform</Link>
            <a href="#how">How It Works</a>
            <a href="#about">About</a>
            <a href="#legal">Legal</a>
            <a href="#contact">Contact</a>
            <Link to="/login">Login</Link>
            <Link to="/signup">Signup</Link>
          </div>
          
          <Link to="/contact" className="btn btn-dark nav-cta" style={{ width: 'auto'}}>
            Request Demo
          </Link>
        </div>
      </nav>

      {/* Spacer for fixed navbar height */}
      <div style={{ height: '64px' }}></div>

      <main>
        {/* This is where Home, Login, or Signup pages render */}
        <Outlet />
      </main>

      <footer className="section--alt">
        <div className="container" style={{ textAlign: 'center' }}>
          <p>© 2026 PropTradingInfra. Professional Trading Infrastructure.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;